// extracted by mini-css-extract-plugin
export default {"heading":"Qv-z","corrected":"Rv-z","redirectVerbiageContainer":"Sv-z","redirectVerbiageText":"Tv-z"};